(() => {
  function getWrapFromButton(btn) {
    return btn ? btn.closest(".video-autoplay") : null;
  }

  function getVideoFromWrap(wrap) {
    return wrap ? wrap.querySelector("video") : null;
  }

  function prepareVideo(video) {
    if (!video) return;

    let needsLoad = false;

    const lazySources = video.querySelectorAll("source[data-src]");
    lazySources.forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute("data-src");
      needsLoad = true;
    });

    // Custom players outside the product gallery keep one set of controls.
    video.controls = false;
    if (!video.dataset.cpPrepared) {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");
      video.dataset.cpPrepared = "true";
    }
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");

    if (needsLoad || video.readyState === 0) {
      video.preload = "metadata";
      video.load();
    }
  }

  function revealVideoFrame(video) {
    const wrap = video ? video.closest(".video-autoplay") : null;
    if (!wrap) return;

    /*
      Delay by two animation frames so the browser has painted
      the first real video frame before the poster fades away.
    */
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        wrap.classList.add("has-frame");
        wrap.classList.add("has-played");
      });
    });
  }

  function syncIcons(video) {
    const wrap = video.closest(".video-autoplay");
    if (!wrap) return;

    const btn = wrap.querySelector(".cp-video-toggle");
    if (!btn) return;

    const isPlaying = !video.paused && !video.ended;
    btn.setAttribute("aria-label", isPlaying ? "Pause product video" : "Play product video");

    const playIcon = btn.querySelector(".cp-play");
    const pauseIcon = btn.querySelector(".cp-pause");

    if (playIcon) playIcon.classList.toggle("cp-hidden", isPlaying);
    if (pauseIcon) pauseIcon.classList.toggle("cp-hidden", !isPlaying);
  }

  function playVideo(video) {
    if (!video) return;

    const wrap = video.closest(".video-autoplay");

    prepareVideo(video);

    if (wrap) {
      wrap.classList.add("is-loading");
    }

    document.querySelectorAll(".video-autoplay video").forEach(other => { if (other !== video) pauseVideo(other); });
    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          if (wrap) {
            wrap.classList.add("is-playing");
          }

          /*
            Do not hide poster instantly.
            Wait for loaded frame/canplay/playing event to reveal.
          */
          if (video.readyState >= 2) {
            revealVideoFrame(video);
          }

          syncIcons(video);
        })
        .catch((err) => {
          console.log("Video play blocked:", err);

          if (wrap) {
            wrap.classList.remove("is-playing");
            wrap.classList.remove("is-loading");
          }

          syncIcons(video);
        });
    }
  }

  function pauseVideo(video) {
    if (!video) return;

    const wrap = video.closest(".video-autoplay");

    if (!video.paused) {
      video.pause();
    }

    if (wrap) {
      wrap.classList.remove("is-playing");
      wrap.classList.remove("is-loading");

      if (video.currentTime > 0 || video.readyState > 1) {
        wrap.classList.add("has-played");
        wrap.classList.add("has-frame");
      }
    }

    syncIcons(video);
  }

  window.cpToggleVideo = function (btn) {
    const wrap = getWrapFromButton(btn);
    const video = getVideoFromWrap(wrap);

    if (!video) return;

    if (video.paused || video.ended) {
      playVideo(video);
    } else {
      pauseVideo(video);
    }
  };

  window.cpToggleFullscreen = function (btn) {
    const wrap = getWrapFromButton(btn);
    const video = getVideoFromWrap(wrap);

    if (!video) return;

    prepareVideo(video);

    const isIOS =
      /iP(ad|hone|od)/.test(navigator.platform) ||
      (navigator.userAgent.includes("Mac") && "ontouchend" in document);

    if (isIOS && video.webkitEnterFullscreen) {
      video.webkitEnterFullscreen();
    } else if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen();
    } else if (wrap && wrap.requestFullscreen) {
      wrap.requestFullscreen();
    }
  };

  document.addEventListener(
    "loadeddata",
    (e) => {
      if (e.target.tagName !== "VIDEO") return;
      revealVideoFrame(e.target);
    },
    true
  );

  document.addEventListener(
    "canplay",
    (e) => {
      if (e.target.tagName !== "VIDEO") return;
      revealVideoFrame(e.target);
    },
    true
  );

  document.addEventListener(
    "playing",
    (e) => {
      if (e.target.tagName !== "VIDEO") return;

      const video = e.target;
      const wrap = video.closest(".video-autoplay");

      if (wrap) {
        wrap.classList.add("is-playing");
        wrap.classList.remove("is-loading");
      }

      if (video.readyState >= 2) {
        revealVideoFrame(video);
      }

      syncIcons(video);
    },
    true
  );

  document.addEventListener(
    "pause",
    (e) => {
      if (e.target.tagName !== "VIDEO") return;

      const video = e.target;
      const wrap = video.closest(".video-autoplay");

      if (wrap) {
        wrap.classList.remove("is-playing");
        wrap.classList.remove("is-loading");

        if (video.currentTime > 0 || video.readyState > 1) {
          wrap.classList.add("has-played");
          wrap.classList.add("has-frame");
        }
      }

      syncIcons(video);
    },
    true
  );

  document.addEventListener(
    "ended",
    (e) => {
      if (e.target.tagName !== "VIDEO") return;

      const video = e.target;
      const wrap = video.closest(".video-autoplay");

      if (wrap) {
        wrap.classList.remove("is-playing");
        wrap.classList.remove("is-loading");
        wrap.classList.add("has-played");
        wrap.classList.add("has-frame");
      }

      syncIcons(video);
    },
    true
  );

  // Customer-controlled playback on every device; never restart a paused video while scrolling.
  const observed = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (!entry.isIntersecting) pauseVideo(entry.target); });
  }, {threshold:0}) : null;
  function mountPlayers() {
    document.querySelectorAll('.video-autoplay video').forEach(video => {
      if (!observed.has(video)) { observed.add(video); observer?.observe(video); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mountPlayers); else mountPlayers();
  document.addEventListener('shopify:section:load',mountPlayers);
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('.video-autoplay video').forEach(video => {pauseVideo(video);observer?.unobserve(video);}));
  document.addEventListener('visibilitychange',() => {if(document.hidden) document.querySelectorAll('.video-autoplay video').forEach(pauseVideo);});
})();
